import { APIService, getCarrierName } from "../utilities/Constants";
import { apiGet } from "./utils/apiUtils";
import { ErrorHandler } from "./utils/errorUtils";

import { messages } from "../../src/resources/strings";
import { toPreviousPaymentsModal } from "../hooks/billing/billingPaymentParser";
import { handleError403Introspection } from "./user";

//API :: Billing and Payments - Get previous payments history
export const getPreviousPaymentsDetails = async (id: string) => {
  const customErrorHandlers: ErrorHandler[] = [
    {
      case: 403,
      onError: () => {
        handleError403Introspection();
      },
    },
  ];
  const response = await apiGet<any>(
    APIService.harmony,
    `/policy/${id}/payments`,
    {},
    { policySource: getCarrierName() },
    customErrorHandlers
  );
  if (response.status === 200) {
    let paymentsArray = response.result;
    let sortedArray = paymentsArray?.sort(function (a: any, b: any) {
      return new Date(b.date).getTime() - new Date(a.date).getTime();
    });

    return {
      response: toPreviousPaymentsModal(sortedArray),
      errorCode: messages.error.noError,
    };
  } else {
    return {
      errorCode: messages.error.somthingWrong,
    };
  }
};
